import { VehicleSearchSortByEnum, VehicleSortEnum } from "../enum/wtb-query-key.enum";

export const OrderByItems = [
  {
    title: VehicleSortEnum.NewArrival,
    params: {
      SortBy: VehicleSearchSortByEnum.NewArrival,
      SortDirection: "DESC" as SortDirection,
    },
  },
  {
    title: VehicleSortEnum.MostView,
    params: {
      SortBy: VehicleSearchSortByEnum.ViewCount,
      SortDirection: "DESC" as SortDirection,
    },
  },
  {
    title: VehicleSortEnum.MileageAsc,
    params: {
      SortBy: VehicleSearchSortByEnum.Mileage,
      SortDirection: "ASC" as SortDirection,
    },
  },
  {
    title: VehicleSortEnum.MileageDesc,
    params: {
      SortBy: VehicleSearchSortByEnum.Mileage,
      SortDirection: "DESC" as SortDirection,
    },
  },
  {
    title: VehicleSortEnum.YearAsc,
    params: {
      SortBy: VehicleSearchSortByEnum.Year,
      SortDirection: "ASC" as SortDirection,
    },
  },
  {
    title: VehicleSortEnum.YearDesc,
    params: {
      SortBy: VehicleSearchSortByEnum.Year,
      SortDirection: "DESC" as SortDirection,
    },
  },
  {
    title: VehicleSortEnum.PriceAsc,
    params: {
      SortBy: VehicleSearchSortByEnum.Price,
      SortDirection: "ASC" as SortDirection,
    },
  },
  {
    title: VehicleSortEnum.PriceDesc,
    params: {
      SortBy: VehicleSearchSortByEnum.Price,
      SortDirection: "DESC" as SortDirection,
    },
  },
];
